import React from 'react';
import styles from './statusText.scss';

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  active?: boolean;
  className?: string;
}

const StatusText: React.FC<Props> = ({ active, className, children, ...rest }) => {
  const classes = {
    base: styles.statusText,
    prop: className || undefined,
    active: active ? styles.statusActive : undefined,
  };
  const classNames = Object.values(classes)
    .join(' ')
    .trim();
  return (
    <span className={classNames} {...rest}>
      {children}
    </span>
  );
};

export default StatusText;
